import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from '@core/helpers/helpers';
import { CursoModel, UtilizadorModel } from '@core/models';
import {
  AccountService,
  CustomMessageService,
  InscricaoService,
  StoreService,
} from '@core/services';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-modal-curo-incricao',
  templateUrl: './modal-curo-incricao.component.html',
  styleUrls: ['./modal-curo-incricao.component.scss'],
})
export class ModalCuroIncricaoComponent implements OnInit {
  @Input() showModal: boolean = false;
  @Input() curso: CursoModel;
  @Output() onClose = new EventEmitter<boolean>();
  utilizador: UtilizadorModel = null;
  tipoPagamentoSelecionado: string = 'TRANSFERENCIA';

  constructor(
    private inscricaoService: InscricaoService,
    private storeService: StoreService,
    private accountService: AccountService,
    private messageService: CustomMessageService,
    private router: Router,
    private helper: Helpers
  ) {}

  ngOnInit(): void {
    this.helper.isAuthenticationChanged().subscribe(r => {
      if (this.helper.isAuthenticated()) this.utilizador = this.helper.getUserLogado();
    });
  }

  inscrever() {
    if (this.storeService.isAuthenticated()) {
      const inscricao = {
        cursoId: this.curso.id,
        tipoPagamento: this.tipoPagamentoSelecionado,
        utilizadorId: this.utilizador.id,
      };

      this.inscricaoService.add(inscricao).subscribe(
        ({ pagamento }) => {
          this.closeModal();
          this.messageService.showToast(
            'Inscrição realizada com sucesso.',
            'success',
            'Após o pagamento, navegue até "Conta" e submeta o comprovativo de pagamento na secção das inscrições. Obrigado!'
          );
        },
        (err) => {
          this.messageService.showToast('Atenção', 'warn', err.mensagem);
          this.showModal = false;
        }
      );
    } else {
      this.messageService
        .customSwal()
        .fire({
          title: '',
          text: 'Inicie sua sessão para se inscrever no curso.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Iniciar Sessão',
          cancelButtonText: 'Cancelar',
        })
        .then((result) => {
          if (result.value) {
            this.router.navigate(['/autenticacao/login']);
          }
        });
    }
  }

  closeModal() {
    this.showModal = false;
    this.onClose.emit(true);
  }
}
